var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 19.6289C10.9375 20.0433 11.1021 20.4407 11.3951 20.7338C11.6882 21.0268 12.0856 21.1914 12.5 21.1914C12.9144 21.1914 13.3118 21.0268 13.6049 20.7338C13.8979 20.4407 14.0625 20.0433 14.0625 19.6289C14.0625 19.2145 13.8979 18.8171 13.6049 18.5241C13.3118 18.231 12.9144 18.0664 12.5 18.0664C12.0856 18.0664 11.6882 18.231 11.3951 18.5241C11.1021 18.8171 10.9375 19.2145 10.9375 19.6289ZM11.7188 15.5273H13.2812C13.3887 15.5273 13.4766 15.4395 13.4766 15.332V4.00391C13.4766 3.89648 13.3887 3.80859 13.2812 3.80859H11.7188C11.6113 3.80859 11.5234 3.89648 11.5234 4.00391V15.332C11.5234 15.4395 11.6113 15.5273 11.7188 15.5273Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationOutlined);
export default __webpack_public_path__ + "static/media/ExclamationOutlined.5462076cf5c0d68930317ca8f6b5bdd5.svg";
export { ForwardRef as ReactComponent };